<template>
  <v-container class="py-6" grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>      
        <p>Bartleho typológia hráčov je dotazník vychádzajúci z teórie R. Bartleho, ktorý rozlišuje preferencie hráčov (a širšie aj užívateľov interaktívnych systémov) do štyroch štýlov: Achiever (A) – orientácia na ciele, výkon a odmeny; Socializer (S) - dôraz na vzťahy a komunitu; Explorer (E) - zvedavosť, objavovanie a experimentovanie; Killer (K) – súťaživosť a dominancia. Nejde o klinickú kategorizáciu; škála slúži na mapovanie motivačných preferencií, ktoré sa môžu kombinovať a meniť v čase.</p>
        <p>Výsledky plánujeme využiť na prispôsobovanie obsahu a mechaník: profilom A zvýrazníme jasné ciele, progres a odmeny; S ponúkneme kolaboratívne úlohy a sociálne prvky; E poskytneme bohaté možnosti prieskumu, skryté súvislosti a voľnosť; K umožníme súťaženie, rebríčky a PvP prvky. Personalizácia prebehne anonymizovane, iba na základe súhlasu, s cieľom zvýšiť angažovanosť, spokojnosť a efektívne učenie.</p>
      </v-flex>

      <v-flex xs12>
        <v-form ref="form" v-model="valid" @submit.prevent="onSubmit">
          <v-layout column>
            <v-card
              v-for="(item, idx) in items"
              :key="item.code"
              class="pa-4 mb-4"
              outlined
            >
              <div class="subtitle-1 font-weight-medium mb-2">
                {{ idx + 1 }}. {{ item.question }}
              </div>

              <v-radio-group
                :value="responses[item.code]"
                @change="setResponse(item.code, $event)"
                :rules="[v => !!v || 'Vyber jednu možnosť']"
                
              >
                <v-radio
                  :label="`${item.options[0].text}`"
                  :value="item.options[0].trait"
                /> 
                <v-radio
                  :label="`${item.options[1].text}`"
                  :value="item.options[1].trait"
                />
              </v-radio-group>
            </v-card>

            <div class="d-flex align-center justify-space-between mt-2">
              <div class="caption grey--text">
                Vyplnené: {{ answeredCount }}/{{ items.length }}
              </div>
              <div v-if="!submitted">
                <v-btn color="primary" type="submit" class="mr-2">Odoslať a vyhodnotiť</v-btn>
                <v-btn color="primary" text @click="resetForm">Vyčistiť</v-btn>
              </div>
            </div>
          </v-layout>
        </v-form>
      </v-flex>

      <v-flex xs12 v-if="submitted" class="mt-6">
        <h2 class="title font-weight-medium">Výsledky</h2>

        <v-layout row wrap>
          <v-flex xs6 sm3 v-for="t in traits" :key="t">
            <v-card outlined class="pa-3 text-xs-center">
              <div class="caption grey--text text--darken-1">{{ traitLabel[t] }}</div>
              <div class="headline font-weight-bold">{{ counts[t] }}</div>
              <div class="caption grey--text text--darken-1">{{ percents[t].toFixed(1) }}%</div>
            </v-card>
          </v-flex>
        </v-layout>

        <!-- Radarový graf -->
        <v-card outlined class="pa-3 mt-4">
          <div class="subtitle-2 mb-2">Rozloženie čŕt (počty z 30 otázok)</div>
          <div class="chart-wrap">
            <canvas ref="radarCanvas" height="260"></canvas>
          </div>
          <div class="d-flex justify-end">
            <v-btn color="primary" type="submit" class="mr-2" @click="closeTest">Koniec</v-btn>
          </div>
        </v-card>

<!--         <v-card outlined class="pa-3 mt-3">
          <div class="subtitle-2 mb-1">Odpovede (JSON)</div>
          <pre class="mb-2">{{ responses }}</pre>
          <v-btn small @click="downloadJSON" depressed>Stiahnuť JSON</v-btn>
        </v-card> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// a) ak používaš NPM: odkomentuj tento import
import axios from '../../axios-auth.js'
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)

export default {
  name: 'BartleSurveyVuetify2Radar',
  data () {
    return {
      valid: false,
      submitted: false,
      traits: ['A', 'S', 'E', 'K'],
      traitLabel: { A: 'Achiever (A)', S: 'Socializer (S)', E: 'Explorer (E)', K: 'Killer (K)' },
      responses: {}, // { B1: 'A'|'S'|'E'|'K', ... }
      counts: { A: 0, S: 0, E: 0, K: 0 },
      percents: { A: 0, S: 0, E: 0, K: 0 },
      radarChart: null,
      agreement: 0,
      startTime: null,

      // OPRAVENÉ páry: B22 (K/E), B27 (K/A), B28 (K/A)
      items: [
        { code: 'B1',  question: 'Čo si v hre viac užívate?', options: [
          { text: 'zabitie veľkého monštra', trait: 'A' },
          { text: 'chválenie sa zabitím svojim priateľom/spoluhráčom', trait: 'S' },
        ]},
        { code: 'B2',  question: 'Čo si viac užívate pri objavovaní sveta?', options: [
          { text: 'zapojenie sa do deja', trait: 'S' },
          { text: 'získanie odmien na konci', trait: 'A' },
        ]},
        { code: 'B3',  question: 'Aký by ste boli radšej?', options: [
          { text: 'populárny', trait: 'S' },
          { text: 'bohatý', trait: 'A' },
        ]},
        { code: 'B4',  question: 'Čo je pre vás na online hre zaujímavejšie?', options: [
          { text: 'informácie o najnovších klebetách', trait: 'S' },
          { text: 'získanie novej položky', trait: 'A' },
        ]},
        { code: 'B5',  question: 'Čo by ste ako hráč v online hre mali radšej?', options: [
          { text: 'súkromný kanál, cez ktorý môžete vy a vaši priatelia komunikovať', trait: 'S' },
          { text: 'vlastný dom v hodnote miliónov zlatých mincí', trait: 'A' },
        ]},
        { code: 'B6',  question: 'Čo by sa vám ako hráčovi v online hre páčilo viac?', options: [
          { text: 'prevádzkovanie vlastnej krčmy', trait: 'S' },
          { text: 'vytváranie vlastných máp sveta a ich predaj', trait: 'E' },
        ]},
        { code: 'B7',  question: 'Čo je pre vás v online hre dôležitejšie?', options: [
          { text: 'počet zapojených ľudí', trait: 'S' },
          { text: 'počet oblastí na preskúmanie', trait: 'E' },
        ]},
        { code: 'B8',  question: 'Čo je pre vás v online hre dôležitejšie?', options: [
          { text: 'kvalita hrania rolí v online hre', trait: 'S' },
          { text: 'jedinečnosť funkcií a herný mechanizmus', trait: 'E' },
        ]},
        { code: 'B9',  question: 'V on-line hre vás prenasleduje monštrum. Čo urobíte?', options: [
          { text: 'požiadate priateľa o pomoc pri jeho zabíjaní', trait: 'S' },
          { text: 'skryjete sa niekde, kde viete, že monštrum vás nebude nasledovať', trait: 'E' },
        ]},
        { code: 'B10', question: 'Ste hráčom online hry a chystáte sa ísť do neznámeho žalára. Koho vyberiete?', options: [
          { text: 'rozprávača, ktorý je váš dobrý priateľ a ktorý bude zabávať vás a vašich priateľov', trait: 'S' },
          { text: 'čarodejníka, ktorý identifikuje položky, ktoré tam nájdete', trait: 'E' },
        ]},
        { code: 'B11', question: 'Radšej by ste:', options: [
          { text: 'porazili svojich nepriateľov', trait: 'K' },
          { text: 'presvedčili svojich nepriateľov, aby pracovali pre vás, nie proti vám', trait: 'S' },
        ]},
        { code: 'B12', question: 'Čo je pre vás vzrušujúcejšie?', options: [
          { text: 'hranie dobre napísaných role-playing scenárov', trait: 'S' },
          { text: 'smrtiaci boj', trait: 'K' },
        ]},
        { code: 'B13', question: 'Akú udalosť si užijete viac?', options: [
          { text: 'výhru v súboji s iným hráčom', trait: 'K' },
          { text: 'prijatie klanom (skupinou iných hráčov)', trait: 'S' },
        ]},
        { code: 'B14', question: 'Je lepšie byť:', options: [
          { text: 'obávaný', trait: 'K' },
          { text: 'milovaný', trait: 'S' },
        ]},
        { code: 'B15', question: 'Čo uprednostníte pri streretutí s hernou osobou?', options: [
          { text: 'vypočujete si, čo chce povedať', trait: 'S' },
          { text: 'ukážete mu ostrú čepeľ vašej sekery', trait: 'K' },
        ]},
        { code: 'B16', question: 'V online hre sa otvára nová oblasť. Na čo sa tešíte viac?', options: [
          { text: 'skúmanie novej oblasti a zistenie jej histórie', trait: 'E' },
          { text: 'byť prvým, kto získa nové objekty z oblasti', trait: 'A' },
        ]},
        { code: 'B17', question: 'V online hre by ste radšej boli známi ako:', options: [
          { text: 'niekto, kto môže bežať medzi ľubovoľnými dvoma miestami na svete a nestratí sa', trait: 'E' },
          { text: 'osoba s najlepším a najunikátnejším vybavením v hre', trait: 'A' },
        ]},
        { code: 'B18', question: 'Čo uprednostníte?', options: [
          { text: 'stať sa hrdinom rýchlejšie ako vaši priatelia', trait: 'A' },
          { text: 'poznať viac tajomstiev ako vaši priatelia', trait: 'E' },
        ]},
        { code: 'B19', question: 'Čo uprednostníte?', options: [
          { text: 'vedieť, kde nájsť veci', trait: 'E' },
          { text: 'vedieť, ako získať veci', trait: 'A' },
        ]},
        { code: 'B20', question: 'Čo by ste radšej urobili?', options: [
          { text: 'vyriešili hádanku, ktorú nikto iný nevyriešil', trait: 'E' },
          { text: 'dostali sa na určitú úroveň skúseností rýchlejšie ako ktokoľvek iný', trait: 'A' },
        ]},
        { code: 'B21', question: 'V online hre by ste sa radšej pridali ku klanu:', options: [
          { text: 'vedci', trait: 'E' },
          { text: 'vrahovia', trait: 'K' },
        ]},
        { code: 'B22', question: 'V online hre by ste uprednostnili:', options: [
          { text: 'poraziť nepriateľa', trait: 'K' },   // oprava
          { text: 'preskúmať novú oblasť', trait: 'E' }, // oprava
        ]},
        { code: 'B23', question: 'Ak sa stane že sa ocitnete v nejakej oblasti sami, myslíte si, že:', options: [
          { text: 'je bezpečné preskúmať ju', trait: 'E' },
          { text: 'budete musieť hľadať korisť inde', trait: 'K' },
        ]},
        { code: 'B24', question: 'Dozviete sa, že iný hráč plánuje vaše zničenie. Čo urobíte?', options: [
          { text: 'pôjdete do oblasti, ktorú váš súper nepozná a pripravíte sa na neho tam', trait: 'E' },
          { text: 'zaútočíte na neho skôr, ako on na vás', trait: 'K' },
        ]},
        { code: 'B25', question: 'Stretnete hráča – nováčika. Myslíte na neho ako na:', options: [
          { text: 'niekoho, kto dokáže oceniť vaše znalosti o hre', trait: 'E' },
          { text: 'potenciálnu korisť', trait: 'K' },
        ]},
        { code: 'B26', question: 'V online hre uprednostníte:', options: [
          { text: 'mať meč dvakrát silnejší ako ktokoľvek iný v hre', trait: 'A' },
          { text: 'byť najobávanejšou osobou v hre', trait: 'K' },
        ]},
        { code: 'B27', question: 'V online hre ste náchylnejší chváliť sa:', options: [
          { text: 'koľko ďalších hráčov ste zabili', trait: 'K' }, // oprava
          { text: 'svojím vybavením', trait: 'A' },                // oprava
        ]},
        { code: 'B28', question: 'Chceli by ste radšej:', options: [
          { text: 'kúzlo na poškodenie ostatných hráčov', trait: 'K' }, // oprava
          { text: 'kúzlo, ktoré zvyšuje rýchlosť získavania skúsenostných bodov', trait: 'A' }, // oprava
        ]},
        { code: 'B29', question: 'Chceli by ste radšej:', options: [
          { text: 'dve úrovne skúseností', trait: 'A' },
          { text: 'amulet, ktorý zvyšuje poškodenie, ktoré spôsobíte iným hráčom o 10%', trait: 'K' },
        ]},
        { code: 'B30', question: 'Pri hraní videohry je zábavnejšie:', options: [
          { text: 'mať najvyššie skóre na zozname', trait: 'A' },
          { text: 'poraziť svojho najlepšieho priateľa jeden na jedného', trait: 'K' },
        ]},
        { code: 'X', question: 'Súhlasím so spracovaním anonymizovaných údajov na vedecké účely:', options: [
          { text: 'áno súhlasím', trait: '1' },
          { text: 'nie nesúhlasím', trait: '0' },
        ]},
      ],
    }
  },
  computed: {
    answeredCount () {
      return Object.keys(this.responses).length
    }
  },
  mounted() {
    this.startTime = Date.now()
  },
  methods: {
    setResponse (code, value) {
      this.$set(this.responses, code, value)
    },
    onSubmit () {
      if (!this.$refs.form.validate()) return
      if (this.submitted) return

      this.submitted = true
      // reset počítadiel
      this.counts = { A: 0, S: 0, E: 0, K: 0 }

      // spočítať črty podľa odpovedí
      this.items.forEach(it => {
        const t = this.responses[it.code]
        if (it.code == 'X') this.agreement = t 
        if (t && this.counts.hasOwnProperty(t)) this.counts[t]++
      })

      const total = this.items.length || 1
      this.percents.A = this.counts.A / total * 100
      this.percents.S = this.counts.S / total * 100
      this.percents.E = this.counts.E / total * 100
      this.percents.K = this.counts.K / total * 100

      this.writeAnswer(1)
      this.renderRadar()
    },
    resetForm () {
      this.$refs.form.resetValidation()
      this.responses = {}
      this.submitted = false
      this.counts = { A: 0, S: 0, E: 0, K: 0 }
      this.percents = { A: 0, S: 0, E: 0, K: 0 }
      this.destroyRadar()
    },
    renderRadar () {
      this.$nextTick(() => {
        const ctx = this.$refs.radarCanvas
        if (!ctx) return
        this.destroyRadar()
        this.radarChart = new Chart(ctx, {
          type: 'radar',
          data: {
            labels: ['Achiever (A)', 'Socializer (S)', 'Explorer (E)', 'Killer (K)'],
            datasets: [{
              label: 'Počet odpovedí',
              data: [this.counts.A, this.counts.S, this.counts.E, this.counts.K],
              fill: true,
              backgroundColor: 'rgba(33,150,243,0.2)',
              borderColor: 'rgba(33,150,243,1)',
              pointBackgroundColor: 'rgba(33,150,243,1)'
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              r: {
                suggestedMin: 0,
                suggestedMax: 10,
                ticks: { stepSize: 5 }
              }
            },
            plugins: {
              legend: { display: true }
            }
          }
        })
      })
    },
    destroyRadar () {
      if (this.radarChart && typeof this.radarChart.destroy === 'function') {
        this.radarChart.destroy()
        this.radarChart = null
      }
    },
    writeAnswer(_final) {
      const _data = {
          id: 0,
          test_id: this.$route.params.id,
          score: -1 ,
          answers : JSON.stringify(this.responses),
          final: _final,
          rslt: JSON.stringify(this.counts),
          agreement: this.agreement,
          time_length: this.startTime ? Math.round((Date.now() - this.startTime)/1000) : 0
        } 
        axios.post('/write-my-person-test-answer', _data, this.$store.getters.getAxiosConfig)
        .then(res => {
            // this.answer_id = res.data.answer_id
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)
        })
    },
    closeTest() {
      this.$router.push({name:'personalisation_tests', params: {}}) 
    },

  }
}
</script>

<style scoped>
pre { white-space: pre-wrap; word-break: break-word; }
.chart-wrap { position: relative; width: 100%; min-height: 260px; }
</style>
